import React, { Component } from 'react';
import CropOverlay from './CropOverlay';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Crop from '@material-ui/icons/Crop';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from './IconButton';
import Cancel from '@material-ui/icons/Cancel';
import NavigateNext from '@material-ui/icons/NavigateNext';
import { withRouter } from 'react-router-dom';


const styles = theme => ({
  paper: {
    maxWidth: theme.contentWidth.main * 0.7,
  },
  paperHeading: {
    padding: theme.spacing.unit * 2,
  },
  paperInfo: {
    padding: theme.spacing.unit,
  },
  paperIcon: {
    marginRight: theme.spacing.unit,
    color: theme.palette.primary.main
  },
  cropImage: {
    userSelect: 'none',
    width: '100%',
    position: 'static'
  },
  footer: {
    display: 'flex',
    textAlign: 'right',
    marginTop: theme.spacing.unit * 2,
    justifyContent: 'space-between',
  },
});


class Cropper extends Component {
  constructor(props) {
    super(props);
    // src
    this.state = {
      imageSize: false,
      imagePos: false,
      imageLoaded: false,
      imageCursor: 'auto',
      validate: false,
      visible: false,
    };
    this.img = null;
  }

  imageOnLoad = e => {
    this.setState({
      imageSize: {
        width: this.img.offsetWidth,
        height: this.img.offsetHeight
      },
      imagePos: {
        x: this.img.offsetLeft,
        y: this.img.offsetTop
      },
      imageLoaded: true,
    });
  }

  setCursor = cursor => {
    this.setState({imageCursor: cursor});
  }

  getCursor = cursor => {
    return this.state.imageCursor;
  }

  updateValidate = validate => {
    this.setState({validate: validate});
  }

  render() {
    const {classes, history, fontLoaded} = this.props;
    return (
      <div>
        {!(this.state.imageLoaded && fontLoaded) &&
          <Grid container justify="center" alignItems="center" className={classes.loading}>
            <CircularProgress color="primary" size={150} thickness={1.5} />
          </Grid>
        }
        <div style={{visibility: this.state.imageLoaded && fontLoaded ? 'visible' : 'hidden' }}>
          <Paper className={classes.paper} style={{maxWidth: this.state.imageSize.width}}>
            <Grid container alignItems="center" className={classes.paperHeading}>
              <Crop className={classes.paperIcon} />
              <Typography variant="subheading">
                裁切圖片
              </Typography>
            </Grid>
            <div
              style={{
                overflow: 'hidden',
                cursor: this.state.imageCursor,
                width: this.state.imageSize.width,
                height: this.state.imageSize.height,
              }}
            >
              <img ref={elm => this.img = elm} className={classes.cropImage}
                src={this.props.src} onLoad={this.imageOnLoad} draggable='false' alt='Uploaded ImageView'
              />
              {this.state.imageLoaded && fontLoaded &&
                <CropOverlay updateValidate={this.updateValidate}
                             imageSize={this.state.imageSize}
                             getCursor={this.getCursor}
                             setCursor={this.setCursor}
                />
              }
            </div>
            <Typography variant="caption" align="right" className={classes.paperInfo} noWrap>
              {this.props.filename}
            </Typography>
          </Paper>
          <div className={classes.footer}>
            <IconButton icon={<Cancel/>} text='取消' className={classes.stepButton} onClick={()=>history.push('/')} isLeft />
            <IconButton icon={<NavigateNext/>} text='下一步' className={classes.stepButton} disabled={!this.state.validate} onClick={()=>this.props.changeMode('submit')} />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(Cropper))


// WEBPACK FOOTER //
// ./src/components/Cropper.js